import { Box, Typography, Container, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

const HeroContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '50vh',
  minHeight: 300,
  maxHeight: 500,
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.common.white,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1,
  },
  [theme.breakpoints.down('sm')]: {
    height: '35vh',
    minHeight: 200,
  },
}));

const ContentContainer = styled(Container)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  textAlign: 'center',
  padding: theme.spacing(4),
}));

// Motion components
const MotionTypography = motion(Typography);
const MotionPaper = motion(Paper);

const Hero = ({ imageUrl, title, subtitle }) => {
  return (
    <HeroContainer 
      sx={{ 
        backgroundImage: `url(${imageUrl})`,
      }}
      component={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <ContentContainer maxWidth="md">
        <MotionTypography
          component="h1"
          variant="h2"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          sx={{
            fontWeight: 700,
            mb: 2,
            textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
            fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem' }
          }}
        >
          {title}
        </MotionTypography>
        
        {subtitle && (
          <MotionPaper 
            elevation={0}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            sx={{ 
              display: 'inline-block', 
              px: 3, 
              py: 1, 
              bgcolor: 'rgba(255, 255, 255, 0.85)',
              borderRadius: 2
            }}
          >
            <Typography 
              variant="h6" 
              component="h2"
              sx={{ 
                color: 'text.primary',
                fontWeight: 500,
                fontSize: { xs: '1rem', sm: '1.25rem' }
              }}
            >
              {subtitle}
            </Typography>
          </MotionPaper>
        )}
      </ContentContainer>
    </HeroContainer>
  );
};

export default Hero;